<!--
    描述：模板设置 --- 入口页面
    时间：2020-11-21
    Created by ws
-->
<template>
	<transition name="fade"
				mode="out-in">
		<!-- 用做缓存页面 -->
		<keep-alive>
			<router-view :key="key" />
		</keep-alive>
	</transition>
</template>

<script>
import { mapState } from 'vuex'
export default {
	name: 'template_setting_entry',
	data() {
		return {}
	},
	methods: {},
	computed: {
		key() {
			return this.$route.name
		}
	}
}
</script>

<style scoped lang="less">
</style>


